// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__37F7t","productName":"Table_productName__uyfoZ"};